<template>
    <alert-base background-color="#E70000">
        <template #icon>
            <alert-icon class="w-6 h-auto" />
        </template>

        <slot />
    </alert-base>
</template>

<script lang="ts" setup>
import AlertIcon from "~/public/icons/alert.svg";
</script>
